import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import OrderPayment from "@/model/OrderPayment";
import { inject, onMounted, reactive, watch } from "vue";
import { PaymentMethod } from "@/model/enum/PaymentMethod";
import { PaymentServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddOrderPaymentPanel',
    props: {
        orderId: { type: Number, required: true }
    },
    emits: ["paymentAdded"],
    setup(__props, { emit: __emit }) {
        const paymentService = inject(PaymentServiceSymbol);
        let payment = reactive(new OrderPayment());
        const emit = __emit;
        const props = __props;
        onMounted(() => payment.orderId = props.orderId);
        watch(() => props.orderId, (newValue) => {
            payment.orderId = newValue;
        });
        function addOrderPayment() {
            paymentService.addPayment(payment)
                .then(() => {
                emit('paymentAdded');
            });
        }
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vc_date_picker = _resolveComponent("vc-date-picker");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, null, {
                activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ class: "ma-2" }, props), {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("Zahlung Hinzufügen")
                        ])),
                        _: 2
                    }, 1040)
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("Neue Zahlung")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_text_field, {
                                rules: [],
                                label: "Höhe",
                                variant: "outlined",
                                modelValue: _unref(payment).amount,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(payment).amount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_vc_date_picker, {
                                modelValue: _unref(payment).date,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(payment).date) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_select, {
                                variant: "outlined",
                                label: "Art",
                                items: Object.values(_unref(PaymentMethod)),
                                modelValue: _unref(payment).paymentMethod,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(payment).paymentMethod) = $event))
                            }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_btn, { onClick: addOrderPayment }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Hinzufügen")
                        ])),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
